import { render, staticRenderFns } from "./User-list.vue?vue&type=template&id=fad9ee68"
import script from "./User-list.vue?vue&type=script&lang=js"
export * from "./User-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports